import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ApiService from "../../../services/api-service";
import notifier from "../../../components/Notifier";
import { addSongAction, addSongsAction } from "../../../action/songs";
import { getBalance } from "../../../asyncAction/asyncBalance";
import {
  isOwnerId,
  isOwner,
  getErrorString,
  fullName,
  copyToClipboard,
  onShare,
  generateDynamicLink,
  getUserDetail,
} from "../../../constants/function";

export default function useArtistProfileActions() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const userDetail = getUserDetail();

  // Handle tip action
  const handleTip = async (amount, id, type, currency, setLoading, setOpenTip) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTip(false);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };

  // Subscribe to artist
  const subscribe = async (id, userData, setUserData, setLoading, setOpen, setShowConfirm) => {
    try {
      setLoading(true);
      const response = await ApiService.SUBSCRIBE_ARTIST({
        artistId: id,
        currency: "siki",
      });
      const temp = userData;
      temp["isSubscribed"] = true;
      temp["subscribedStatus"] = "Active";
      temp["subscriptionStatus"] = "enabled";
      setUserData({ ...temp });
      setLoading(false);
      setOpen(true);
      setShowConfirm(false);
      dispatch(getBalance());
    } catch (error) {
      setLoading(false);
      setShowConfirm(false);
      notifier.error(getErrorString(error));
      history.push("/app/Wallet/addBalance");
    }
  };

  // Unsubscribe from artist
  const unSubscribe = async (id, userData, setUserData, setLoading, setMessage, setOpen) => {
    try {
      setLoading(true);
      const response = await ApiService.UNSUBSCRIBE_ARTIST({
        artistId: id,
        currency: "siki",
      });
      setMessage(t("success.message8"));
      const temp = userData;
      temp["subscribedStatus"] = "Unsubscribed";
      setUserData({ ...temp });
      setLoading(false);
      setOpen(true);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  // Follow/unfollow artist
  const follow = async (artistId, userData, setUserData, setLoading) => {
    try {
      setLoading(true);
      const payload = {
        following: artistId,
        status: !userData["isFollowed"],
      };
      const response = userData["isFollowed"]
        ? await ApiService.UNFOLLOW(payload)
        : await ApiService.FOLLOW(payload);
      setLoading(false);
      const data = userData;
      data["isFollowed"] = !userData["isFollowed"];
      setUserData({ ...data });
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  // Flag user
  const flagUser = async (userData, setLoading) => {
    try {
      setLoading(true);
      const response = await ApiService.FLAG_USER({
        message: "Reason",
        assetId: userData["_id"],
        verify: userData["_id"],
      });
      notifier.success(t("notifier.success.toast8"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // Toggle menu action
  const toggleMenu = (value, id, index, tab, isplaylist, isMusic, setSelectedAlbum, makeAction) => {
    setSelectedAlbum(id);
    if (value && id) makeAction(value, id, index, tab, isMusic);
  };

  // Make action based on menu selection
  const makeAction = async (key, id, index, tab, isMusic, userData, music, topMusic, nftMusic, playlistMusic, albums, playlistNft, setShowPlaylist, getPlayListMusic) => {
    switch (key) {
      case "m2":
        if (tab === 0 && topMusic.length) {
          if (
            !isOwnerId(userData["_id"]) &&
            !userData["isSubscribed"] &&
            topMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast15"));
          else {
            dispatch(addSongAction(topMusic[index], null, true));
          }
        } else if (tab === 1) {
          if (
            tab === 1 &&
            music[index]["uploader"] &&
            !music[index]["uploader"]["isSubscribed"] &&
            music[index]["private"]
          ) {
            notifier.error(t("notifier.error.toast15"));
          } else {
            dispatch(addSongAction(music[index], null, true));
          }
        } else if (tab === 3) {
          if (!nftMusic[index]["isSubscribed"] && nftMusic[index]["private"])
            notifier.error(t("notifier.error.toast15"));
          else dispatch(addSongAction(nftMusic[index], null, true));
        } else if (tab === 2 || tab === 5) {
          const isPlaylist = tab === 2 || tab === 5 ? true : false;
          dispatch(
            addSongAction(
              tab === 0
                ? topMusic[index]
                : tab === 1
                  ? music[index]
                  : tab === 3 && nftMusic[index]["musicDetails"]
                    ? nftMusic[index]["musicDetails"]
                    : music[index],
              isPlaylist ? music["_id"] : null,
              true
            )
          );
        }
        break;

      case "m3":
        if (
          tab === 0 &&
          topMusic[index]["uploader"] &&
          !topMusic[index]["uploader"]["isSubscribed"] &&
          topMusic[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else if (
          tab === 1 &&
          music[index]["uploader"] &&
          !music[index]["uploader"]["isSubscribed"] &&
          music[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else if (
          tab === 3 &&
          !nftMusic[index]["isSubscribed"] &&
          nftMusic[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else setShowPlaylist(true);
        break;

      case "m1":
        if (tab != undefined && tab === 0) {
          history.push(
            topMusic[index]?.nftId
              ? `/app/SongDetail/${topMusic[index]?.nftId}`
              : `/app/SongDetails/${id}`
          );
        } else if (tab && tab === 1) {
          history.push(
            music[index]?.nftId
              ? `/app/SongDetail/${music[index]?.nftId}`
              : `/app/SongDetails/${id}`
          );
        } else if (
          tab &&
          tab === 3 &&
          !nftMusic[index]["isSubscribed"] &&
          nftMusic[index]["private"]
        ) {
          notifier.error(t("notifier.error.toast10"));
        } else {
          history.push(
            `/app/SongDetail/${nftMusic[index]["nftId"]
              ? nftMusic[index]["nftId"]
              : nftMusic[index]["_id"]
            }`
          );
        }
        break;

      case "m26":
        if (tab === 2) {
          if (
            !isOwner(
              playlistMusic[index]["createdByDetails"]
                ? playlistMusic[index]["createdByDetails"]["email"]
                : ""
            ) &&
            playlistMusic[index]["createdByDetails"] &&
            !playlistMusic[index].isSubscribed &&
            playlistMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast15"));
          else {
            const tempMusic = await getPlayListMusic(id);
            dispatch(addSongsAction(tempMusic, false, id, 0));
          }
        } else if (tab === 4) {
          dispatch(addSongsAction(albums[index]["music"], false, null, 0, id));
        } else if (
          !isOwner(
            playlistNft[index]["owner"]
              ? playlistNft[index]["owner"]["email"]
              : ""
          ) &&
          !playlistNft[index]["isSubscribed"] &&
          playlistNft[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else {
          const tempMusic = await getPlayListMusic(id);
          tempMusic.forEach((m, index) => dispatch(addSongAction(m, id, true)));
        }
        break;

      case "m27":
        if (
          tab === 5 &&
          playlistNft[index]["owner"] &&
          playlistNft[index]["owner"]["_id"]
        )
          history.push(
            `/app/PlaylistStatics/${id}/${playlistNft[index]["owner"]["_id"]}`
          );
        else
          history.push(
            `/app/PlaylistStatics/${id}/${playlistMusic[index]["createdBy"]}`
          );
        break;

      case "m28":
        history.push(`/app/AlbumDetail/${albums[index]["_id"]}`);
        break;

      case "m8":
        if (tab === 2 && playlistMusic[index]["nftId"]) {
          if (
            !isOwnerId(playlistMusic[index]["owner"]) &&
            !playlistMusic[index]["isSubscribed"] &&
            playlistMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast9"));
          else
            history.push(
              `/app/PlaylistNftDetail/${playlistMusic[index]["nftId"]}`
            );
        } else if (tab === 3) {
          if (isMusic) {
            if (
              !isOwner(
                music[index]["owner"] ? music[index]["owner"]["email"] : ""
              ) &&
              !music[index]["isSubscribed"] &&
              music[index]["private"]
            )
              notifier.error(t("notifier.error.toast9"));
            else history.push(`/app/NftDetail/${id}`);
          } else if (
            !isOwner(
              nftMusic[index]["owner"] ? nftMusic[index]["owner"]["email"] : ""
            ) &&
            !nftMusic[index]["isSubscribed"] &&
            nftMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast9"));
          else history.push(`/app/NftDetail/${nftMusic[index]["nftId"]}`);
        }
        break;

      default:
        break;
    }
  };

  // Handle trending music/playlist play
  const handleTrending = async (type, trendingMusic) => {
    if (type === "music") {
      if (
        !trendingMusic?.topMusic["isSubscribed"] &&
        trendingMusic?.topMusic["private"]
      ) {
        notifier.error(t("notifier.error.toast5"));
      } else dispatch(addSongAction(trendingMusic?.topMusic));
    } else {
      history.push(`/app/Music/${trendingMusic?.topPlaylist?._id}`);
    }
  };

  // Play all songs
  const playAll = async (index, music, active) => {
    if (
      active === 1 &&
      !isOwnerId(music[index]["createdBy"] ? music[index]["createdBy"] : "") &&
      !music[index]["isSubscribed"] &&
      music[index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (music && music.length > 0) {
      if (active === 1) {
        history.push(`/app/Music/${music[index]["_id"]}`);
      } else if (active === 2) {
        history.push(`/app/MyNft/${music[index]["nftId"]}`);
      } else if (active === 3) {
        history.push(`/app/AlbumDetail/${music[index]["_id"]}`);
      } else {
        dispatch(
          addSongsAction(music, false, null, index !== undefined ? index : 0)
        );
      }
    }
  };

  // Handle copy/share actions
  const handleCopy = async (action, studioOption, trendingMusic) => {
    const trending = studioOption ? trendingMusic.topPlaylist : trendingMusic.topMusic;
    const type = studioOption ? 'studio' : 'song';
    const link = await generateDynamicLink(type, trending._id, trending.title, '', trending.thumbnailImg.filePath);

    switch (action) {
      case "m14":
        copyToClipboard(link);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, link, {
          id: userDetail._id,
          referralLink: link,
          eventType: ["sharedOutbound"],
          eventAsset: userDetail._id,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, link, {
          id: userDetail._id,
          referralLink: link,
          eventType: ["sharedOutbound"],
          eventAsset: userDetail._id,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, link);
        break;
      default:
        break;
    }
  };

  return {
    handleTip,
    subscribe,
    unSubscribe,
    follow,
    flagUser,
    toggleMenu,
    makeAction,
    handleTrending,
    playAll,
    handleCopy,
  };
}